import { get } from 'lodash';
import { Node_Type } from '@wix/ricos';
import { getCustomCoverImage, getResolvedCoverImage } from './get-post-cover-deprecated';
import { resizeThumbnail } from './image-utils';
import { getVideoUrl } from './video-utils';
export const getRichContentPostCover = (post, imageHost, videoHost) => {
    const resolvedCoverImage = getResolvedCoverImage(post);
    if (resolvedCoverImage) {
        return resolvedCoverImage;
    }
    let { imageMetadata, isCustom, isEnabled } = getCustomCoverImage(post);
    let videoMetadata;
    if (!imageMetadata) {
        imageMetadata = getPostImageCover(post.content);
    }
    if (!imageMetadata) {
        videoMetadata = getRichContentPostVideoEmbedCover(post.content, imageHost, videoHost);
    }
    return {
        shouldRender: Boolean(imageMetadata || videoMetadata) && isEnabled,
        imageMetadata,
        videoMetadata,
        src: imageMetadata || get(videoMetadata, 'thumbnail_url'),
        isEnabled,
        isCustom,
    };
};
export const getRichContentPostVideoEmbedCover = (content, imageHost, videoHost) => {
    const nodes = content.nodes ?? [];
    const node = nodes.find((n) => n.type === Node_Type.VIDEO);
    if (node?.videoData) {
        const thumbnail = node.videoData.thumbnail || {};
        const videoUrl = node.videoData.video?.src?.id
            ? getVideoUrl({ videoHost, pathname: node.videoData.video.src.id })
            : node.videoData.video?.src?.url;
        if (thumbnail.src?.id) {
            const resized = resizeThumbnail({
                pathname: thumbnail.src?.id || '',
                width: thumbnail.width,
                height: thumbnail.height,
                imageHost,
            });
            return {
                thumbnail_url: resized.url,
                thumbnail_height: resized.height,
                thumbnail_width: resized.width,
                video_url: videoUrl,
            };
        }
        return {
            thumbnail_url: thumbnail.src?.url,
            thumbnail_height: thumbnail.height,
            thumbnail_width: thumbnail.width,
            video_url: videoUrl,
        };
    }
    return undefined;
};
const getPostImageCover = (content) => {
    const nodes = content.nodes ?? [];
    const image = nodes.find((node) => node.type === Node_Type.IMAGE);
    if (image?.imageData) {
        return {
            id: image.imageData.image?.src?.id || image.imageData.image?.src?.url,
            file_name: image.imageData.image?.src?.id || image.imageData.image?.src?.url,
            width: image.imageData.image?.width,
            height: image.imageData.image?.height,
        };
    }
    const gallery = nodes.find((node) => node.type === Node_Type.GALLERY);
    if (gallery?.galleryData) {
        const firstGalleryItem = gallery.galleryData?.items?.[0];
        if (firstGalleryItem) {
            return {
                id: firstGalleryItem.image?.media?.src?.id || firstGalleryItem.image?.media?.src?.url,
                file_name: firstGalleryItem.image?.media?.src?.id || firstGalleryItem.image?.media?.src?.url,
                width: firstGalleryItem.image?.media?.width,
                height: firstGalleryItem.image?.media?.height,
            };
        }
    }
    return undefined;
};
//# sourceMappingURL=post-cover-utils.js.map